document.addEventListener("DOMContentLoaded", function () {
  const dropdownButton = document.getElementById("dropdownParent");
  const dropdownContent = document.getElementById("dropdownContent");

  dropdownButton.addEventListener("mouseenter", function () {
    dropdownContent.classList.add("show");
  });

  dropdownButton.addEventListener("mouseleave", function () {
    dropdownContent.classList.remove("show");
  });

  dropdownContent.addEventListener("mouseleave", function () {
    dropdownContent.classList.remove("show");
  });

  dropdownContent.querySelectorAll("p").forEach(function (option) {
    option.addEventListener("click", function () {
      const selectedValue = this.getAttribute("data-value");
      if (selectedValue === "CA") {
        window.location.href = "/";
      } else if (selectedValue === "US") {
        window.location.href = "/";
      }
    });
  });
});
